import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IProgramCode } from '@interfaces/programCodes';
import { handleGetProgramCodes } from '@store/features/programCodes/actions';
import {
  programCodesErrorSelector,
  programCodesIsLoadingSelector,
  programCodesIsReadySelector,
  programCodesSelector,
} from '@store/features/programCodes/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useProgramCodes = (): IProgramCode[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(programCodesSelector);
  const isLoading = useSelector(programCodesIsLoadingSelector);
  const isReady = useSelector(programCodesIsReadySelector);
  const error = useSelector(programCodesErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetProgramCodes());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.programCodesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useProgramCodes);
